// ===== CREW DAYS-OFF (single source, 2026-08-06 — Susie's ask) =====
// "Is this person off on date X?" has TWO answers that must agree
// everywhere: per-date crew_availability rows (board right-click +
// specific requests from the Crew page Days Off modal; status
// 'off_requested' or 'scheduled_off', reason in note) and the crew
// member's recurring_days_off int[] (sql/077, 0=Sun..6=Sat, weekly
// cyclical days for part-timers — virtual, never materialized as rows).
// The dispatch board cells, the drop/assign guards, and Capacity all
// consult THIS module so the two sources can't drift.

export const OFF_STATUSES = new Set(['off_requested', 'scheduled_off']);

const dowOf = (dateIso) => new Date(dateIso + 'T12:00:00').getDay();

// → { off: false } or
//   { off: true, source: 'date'|'recurring', status, note }
export function crewOffInfo(member, dateIso, availability) {
    if (!member || !dateIso) return { off: false };
    const row = (availability || []).find(a => a.crew_id === member.id && a.date === dateIso);
    if (row && OFF_STATUSES.has(row.status)) {
        return { off: true, source: 'date', status: row.status, note: row.note || '' };
    }
    if (Array.isArray(member.recurring_days_off) && member.recurring_days_off.includes(dowOf(dateIso))) {
        return { off: true, source: 'recurring', status: 'recurring_off', note: 'Weekly day off' };
    }
    return { off: false };
}

export const isCrewOff = (member, dateIso, availability) => crewOffInfo(member, dateIso, availability).off;

// dow → [names] for capacity-style supply math over date ranges.
export function recurringOffByDow(crew) {
    const map = new Map();
    for (const m of (crew || [])) {
        if (m.active === false) continue;
        for (const d of (m.recurring_days_off || [])) {
            if (!map.has(d)) map.set(d, []);
            map.get(d).push(m.name);
        }
    }
    return map;
}

export const DOW_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
